export const NoDownloadFileContainer = ({ familyName }) => {
  return (
    <div className="col-lg-12" id="no-download-family">
      {/* Inner Title */}
      <div className="question-innerTitle">
        <h5>No downloads currently available for {familyName}</h5>
        <MailContainerSubTitle />
      </div>
    </div>
  );
};

export const MailContainerSubTitle = () => {
  return (
    <p>
      Please contact us with your download requirements,e.g. User Manual, Data
      Sheet, etc and will get back to you.
    </p>
  );
};
